import React, { useState } from "react";

import { Row, Col, Table, Button, Popconfirm, Divider } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Form, Select, Input, DatePicker } from "formik-antd";

import { isNotValid, translateSymfonyErrorToFormik } from "../../../core/utils/form";

/* Form & Form Validation */
import * as Yup from "yup";
import Moment from "moment";

import ModalForm from "../../../core/components/form/modalForm";

import PropTypes from "prop-types";

const propTypes = {
    buttonLabel: PropTypes.string,
    buttonType: PropTypes.string,
    onUpload: PropTypes.func.isRequired,
    fileRequired: PropTypes.string,
};

const defaultProps = {
    buttonLabel: "Payment",
    buttonType: "primary",
    fileRequired: true,
};

const validationSchemaWithFile = Yup.object().shape({
    date: Yup.string().required("Cannot be blank."),
    file: Yup.mixed().required("Cannot be blank."),
});

const validationSchema = Yup.object().shape({
    date: Yup.string().required("Cannot be blank."),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 16 },
};

function PaymentButton(props) {
    const { buttonLabel, onUpload } = props;
    const [modalVisible, setModalVisible] = useState(false);

    const defaultValue = {
        file: null,
        date: Moment(),
        amount: props.amountValue,
        notes: props.defaultText ? props.defaultText : "",
    };

    const showModal = () => {
        setModalVisible(true);
    };
    const closeModal = () => setModalVisible(false);
    const onSubmit = (values, bag) => {
        const form = new FormData();
        const date = values.date == null ? null : Moment(values.date).format("YYYY-MM-DD");
        form.append("date", date);
        form.append("file", values.file);
        /*
        form.append("amount", values.amount);*/
        if (values.notes) {
            form.append("notes", values.notes);
        }

        const ret = onUpload(form);

        ret.then((response) => {
            bag.setSubmitting(false);
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
            } else {
                closeModal();
            }
        }).catch((e) => {
            //alert("Se ha producido un error desconocido");
        });

        return;
    };

    return (
        <>
            <Button type={props.buttonType} size="small" onClick={showModal}>
                {buttonLabel}
            </Button>

            {modalVisible && (
                <ModalForm
                    title="Payment"
                    enableReinitialize={true}
                    initialValues={defaultValue}
                    validationSchema={props.fileRequired ? validationSchemaWithFile : validationSchema}
                    onSubmit={onSubmit}
                    onCancel={closeModal}
                    visible={modalVisible}
                    render={({ isSubmitting, touched, errors, values, setFieldValue, setFieldTouched }) => (
                        <>
                            <Form.Item label="Date" name="date" hasFeedback={true} showValidateSuccess={true} required>
                                <DatePicker name="date" format="YYYY-MM-DD" placeholder="Date" />
                            </Form.Item>

                            <Form.Item label="Amount" name="amount">
                                <Input name="amount" placeholder="Amount" suffix={props.amountType} disabled />
                            </Form.Item>

                            <Form.Item label="Receipt" name="file" hasFeedback={true} required={props.fileRequired}>
                                <input
                                    name="file"
                                    type="file"
                                    onChange={(event) => {
                                        setFieldValue("file", event.currentTarget.files[0]);
                                    }}
                                />
                            </Form.Item>

                            <Form.Item label="Notes" name="notes">
                                <Input.TextArea name="notes" placeholder="Notes" />
                            </Form.Item>
                        </>
                    )}
                />
            )}
        </>
    );
}

PaymentButton.propTypes = propTypes;
PaymentButton.defaultProps = defaultProps;

export default PaymentButton;
